import * as React from "react";

import { setIsCreateComponentFormVisible } from "@v1/reducers/ui-reducer";
import { useEditorDispatch, useEditorSelector } from "@v1/store/store";

/**
 * Hook to deal with create component form visibility.
 * It bridges the state on Redux and accepts an optional
 * callback which is called anytime visibility is turned on.
 */
export default function useCreateComponentForm(onVisible?: () => void) {
  const isCreateComponentFormVisible = useEditorSelector(
    (state) => state.ui.isCreateComponentFormVisible,
  );
  const dispatch = useEditorDispatch();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Disable exhaustive deps for now
  React.useEffect(() => {
    if (isCreateComponentFormVisible) {
      onVisible?.();
    }
  }, [isCreateComponentFormVisible]);

  return {
    isCreateComponentFormVisible,
    setIsCreateComponentFormVisible: React.useCallback(
      (value: boolean) => {
        dispatch(setIsCreateComponentFormVisible(value));
      },
      [dispatch],
    ),
  };
}
